// components/LandingPage.tsx
import { useEffect, useState } from 'react';
import { auth, db } from '../firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import Silk from '../blocks/Backgrounds/Silk/Silk';
import { Navbar } from '../components/WebNavbar';
import { HeroSection } from '../sections/HeroSection';
import { NewSpotifySection } from '../sections/NewSpotifySection';
import { MapsSection } from '../sections/MapsSection';
import { IOSInstallOverlay } from '../components/HeroIOSInstallOverlay';
import { MobileAppLayout } from '../components/MobileAppLayout';
import { useIOSInstallPrompt } from '../hooks/useIOSInstallPrompt';
import { useIsMobile } from '../hooks/useIsMobile';
import { useIsPWA } from '../hooks/useIsPWA';
import { useAppNavigation } from '../hooks/useAppNavigation';
import { useAuthState } from 'react-firebase-hooks/auth';

const LandingPage = () => {
  // Hooks
  const { showPrompt, hidePrompt } = useIOSInstallPrompt();
  const isMobile = useIsMobile();
  const isPWA = useIsPWA();
  const { currentView, navigateTo } = useAppNavigation();
  const [user, loading, error] = useAuthState(auth);
  const [specialTitle, setSpecialTitle] = useState<string | undefined>(undefined);

  // Determinar si usar layout de app móvil
  const useMobileAppLayout = isMobile && isPWA;

  // Efecto para registrar la visita
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        addDoc(collection(db, 'pageVisits'), {
          userId: user.uid,
          timestamp: serverTimestamp(),
        });
        unsubscribe();
      }
    });

    return () => unsubscribe();
  }, []);

  // Si es PWA móvil, usar el layout de app
  if (useMobileAppLayout) {
    return (
      <MobileAppLayout 
        currentView={currentView} 
        onNavigate={navigateTo}
        userId={user?.uid || 'mauricio'}
      userName={user?.displayName || user?.email?.split('@')[0] || 'Mauricio'}
      />
    );
  }

  // Layout tradicional para navegador/desktop
  return (
    <>
      {/* El fondo Silk ahora es fijo y está detrás de todo */}
      <div className="fixed inset-0 z-0">
        <Silk
          speed={5}
          scale={1}
          color="#0066ff"
          noiseIntensity={1.0}
          rotation={0}
        />
      </div>

      {/* La barra de navegación se renderiza aquí */}
      <Navbar specialTitle={specialTitle} />

      {/* El main ahora contiene todas las secciones una tras otra */}
      <main className="relative z-10">
        <HeroSection onTitleChange={setSpecialTitle} />
        <NewSpotifySection />
        <MapsSection />
      </main>

      {/* Overlay de instalación iOS - Solo aparece en navegador */}
      <IOSInstallOverlay 
        isVisible={showPrompt} 
        onClose={hidePrompt}
      />
    </>
  );
};

export default LandingPage;